export const tagColors = {
  Insights: "#0099CB",
  "Client Results": "#5DB46E",
  "@CRG": "#8CA3B5",
}
